import { LoanBoardContent } from "../../components/accounting";

export default function LoanBoard() {
  return <LoanBoardContent />;
}
